import { Box, styled } from '@qwealth/qcore';

interface TransitionBoxProps {
  index: number;
  isVisible: boolean;
}

const TransitionBox = styled(Box)<TransitionBoxProps>`
  opacity: 0;
  animation: ${({ isVisible }) => (isVisible ? 'fadeInUp' : 'fadeOutDown')} 0.5s ease-out;
  animation-fill-mode: forwards;
  animation-delay: ${({ index }) => (index * 0.1 < 1 ? index * 0.1 : 1)}s; // ternary to prevent elements from being hidden longer than 1s

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeOutDown {
    from {
      opacity: 1;
      transform: translateY(0);
    }
    to {
      opacity: 0;
      transform: translateY(20px);
    }
  }
`;

export default TransitionBox;
